import React, { createContext, useContext, useState, useMemo } from 'react';

const ReviewModeContext = createContext({
  reviewing: false,
  setReviewing: () => {},
});

export const ReviewModeProvider = ({ children }) => {
  const [reviewing, setReviewing] = useState(false);
  const value = useMemo(() => ({ reviewing, setReviewing }), [reviewing]);
  return (
    <ReviewModeContext.Provider value={value}>
      {children}
    </ReviewModeContext.Provider>
  );
};

export const useReviewMode = () => useContext(ReviewModeContext);
